import type { DeviceSettings } from "@-/dev.improve.haniverse.lib.device-settings";

/** The panel's subviews, in the order of its glass tabs. */
export const ADMIN_PANEL_TABS = [
  { id: "level", label: "Level" },
  { id: "review-queue", label: "Review queue" },
  { id: "wallet", label: "Wallet" },
  { id: "data", label: "Deck & data" },
] as const;

export type AdminPanelTab = (typeof ADMIN_PANEL_TABS)[number]["id"];

/** Which window edge the panel grows from. */
export type AdminPanelPlacement = DeviceSettings["adminPanelPlacement"];

/** The drag handle along the sheet's free edge. */
export const ADMIN_PANEL_HANDLE_HEIGHT = 32;
